module.exports = __webpack_public_path__ + "img/checked-box-green.9c82893b.svg";